import React, {ReactElement} from 'react';
import styled from 'styled-components';

const StyledEmojiSpan = styled.span`
  display: inline-block;
  height: 1em;
  width: 1em;
  margin-bottom: -1px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-image: url('https://assets.frontapp.com/emoji-data-1806/img-apple-64/1f625.png');

  font-size: 1.4em;
  vertical-align: text-bottom;
`;

export const errorFallbackMessage: ReactElement = (
  <>
    Something went wrong <StyledEmojiSpan role="img" aria-label="Sad but relieved" />
  </>
);
